import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

import { Admin } from '../interfaces/admin.type';
import { Router } from '@angular/router';
import { NzNotificationService } from 'ng-zorro-antd/notification';

const USER_AUTH_API_URL = '/api/v1/quiz/account/administrateurs/signin';

const REFRESH_TOKEN_API_URL =
  '/api/v1/quiz/account/administrateurs/refresh-token/';

const ADD_ADMIN_API_URL =
  '/api/v1/quiz/account/administrateurs/addadministrateur';

const GET_ADMIN_API_URL =
  '/api/v1/quiz/account/administrateurs/getadministrateurs';

const UPDATE_ADMIN_API_URL =
  '/api/v1/quiz/account/administrateurs/updateadministrateur/';

const DELETE_ADMIN_ACCOUNT_API_URL =
  '/api/v1/quiz/account/administrateurs/deleteadministrateur/';

// const TOGGLE_QUIZ_STATUS = ''

const FORGOT_PASSWORD_API_URL =
  '/api/v1/quiz/account/administrateurs/forgot-password/';

const CHANGE_PASSWORD_API_URL =
  '/api/v1/quiz/account/administrateurs/update-password';

const RESET_PASSWORD_API_URL =
  '/api/v1/quiz/account/administrateurs/forgot-password/change-password/';

const SIGN_UP = '/api/v1/quiz/account/administrateurs/sign-up';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  private currentUserSubject: BehaviorSubject<Admin>;
  isAuthenticated: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  public currentUser: Observable<Admin>;
  private BASE_URL = environment.BASE_URL;

  constructor(private http: HttpClient, private router: Router, private notification:NzNotificationService) {
    this.currentUserSubject = new BehaviorSubject<Admin>(
      JSON.parse(localStorage.getItem('currentUser'))
    );
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): Admin {
    return this.currentUserSubject.value;
  }

  public setCurrentUser(user: Admin) {
    this.currentUserSubject.next(user);
  }

  login(username: string, password: string, token: string): Observable<Admin> {
    return this.http
      .post<any>(`${this.BASE_URL}${USER_AUTH_API_URL}`, {
        email: username,
        motdepasse: password,
        registrationtoken: null,
      })
      .pipe(
        map((admin) => {
          if (admin && admin.accessToken) {
              if(admin.user.fournisseur && admin.user.fournisseur.status != "ACTIF" ){
this.notification.success(
                  "Attente de validation",
                  'Votre compte est en attente de validation'
                );

              }
              else{
localStorage.setItem('currentUser', JSON.stringify(admin));
            this.isAuthenticated.next(true);
            this.currentUserSubject.next(admin);

              }


          } else {
            throw Error('Utilisateur introuvable');
          }
          return admin;
        })
      );
  }

  signUp(adminData: any, founderId: any): Observable<any> {
    try {
      const formData = new FormData();
      const adminDataX = {
        nom: adminData?.name,
        prenoms: adminData?.surName,
        email: adminData?.email,
        password: adminData?.password,
        contact: adminData?.contact,
        fournisseurid: founderId,
        roleid: adminData.roleid,
      };
      formData.append('administrateurDtoToString', JSON.stringify(adminDataX));

      console.log('Creation compte...', formData);

      return this.http
        .post<any>(`${this.BASE_URL}${ADD_ADMIN_API_URL}`, formData)
        .pipe(
          tap({
            next: (data) => {
              console.log(data, data.email, data.password);
            },
            error: (err) => {
              // Gérer l'erreur ici
              console.log(err);
            },
          })
        );
    } catch (error) {
      console.log(error);
    }
  }

  refreshToken() {
    try {
      console.log('entrée dans le refresh token...');
      const currentUser: Admin = JSON.parse(
        localStorage.getItem('currentUser')
      );
      if (currentUser && currentUser.accessToken) {
        console.log('currentUser Existe : ', currentUser);
        return this.http
          .get<any>(
            `${this.BASE_URL}${REFRESH_TOKEN_API_URL}${currentUser.refreshToken}`,
            {
              headers: {
                Authorization: `Bearer ${currentUser.accessToken}`,
              },
            }
          )
          .pipe(
            tap({
              next: (data) => {
                console.log('reussite : ', data);
              },
              error: (err) => {
                console.log('erreur : ', err);
              },
            })
          );
      } else {
        this.router.navigate(['/auth/']);
        return of([]);
      }
    } catch (error) {
      console.log("Une erreur dans l'api de refrsh token : ", error);
    }
  }

  logout() {
    localStorage.removeItem('currentUser');
    localStorage.removeItem('user_info');
    this.router.navigate(['/auth/']);
    this.currentUserSubject.next(null);
  }

  getAdminById(id: number): Observable<any> {
    return this.http
      .get<any>(
        `${this.BASE_URL}${GET_ADMIN_API_URL}?pagination=false&administrateurid=${id}`
      )
      .pipe(
        tap({
          next: (data) => {
            // console.log('l admin correspondant : ', data);
          },
          error(err) {
            console.log('errreur survenue : ', err);
          },
        })
      );
  }

  getAllFournisseurAdmin(
    paginate: boolean = false,
    page: number = 0,
    size: number = 10,
    filters: any = {}
  ): Observable<any> {
    let params = new HttpParams()
      .set('pagination', String(paginate))
      .set('page', String(page))
      .set('size', String(size));

    for (const key in filters) {
      if (filters.hasOwnProperty(key)) {
        params = params.set(key, filters[key]);
      }
    }
    return this.http
      .get<any>(`${this.BASE_URL}${GET_ADMIN_API_URL}`, { params })
      .pipe(
        tap({
          next: (data) => {
            console.log('l admin correspondant : ', data);
          },
          error: (err) => {
            console.log('errreur survenue : ', err);
          },
        })
      );
  }

  updateAdminProfile(
    id: number,
    uuid: string,
    data: any,
    image?: File
  ): Observable<any> {
    const formData = new FormData();

    const adminDataX = {
      nom: data?.name,
      prenoms: data?.surname,
      contact: data?.phoneNumber,
      roleid: this.currentUserValue.user.role.roleid,
    };
    console.log(adminDataX)

    if (Object.values(adminDataX).some((item) => item === undefined)) {
      console.log('AdminX est vide', adminDataX);
      formData.append(
        'administrateurDtoToString',
        JSON.stringify({
          nom: this.currentUserValue.user.nom,
          prenoms: this.currentUserValue.user.prenoms,
          contact: this.currentUserValue.user.contact,
          roleid: this.currentUserValue.user.role.roleid,
        })
      );
    } else {
      console.log('AdminX est definie', adminDataX);
      formData.append('administrateurDtoToString', JSON.stringify(adminDataX));
    }

    if (image) {
      formData.append('image', image);
    }

    console.log('data : ', data);
    return this.http.put(
      `${this.BASE_URL}${UPDATE_ADMIN_API_URL}${id}/${uuid}`,
      formData
    );
  }

  changePassword(data: any): Observable<any> {
    let dataX = {
      email: this.currentUserValue.user.email,
      lastpassword: data.password,
      newpassword: data.newPassword,
    };
    console.log('charge utile :', dataX);
    return this.http.put(`${this.BASE_URL}${CHANGE_PASSWORD_API_URL}`, dataX);
  }

  // Enregistrer fournisseur  et administrateur via une seul requete
  bothMixAuth(adminData: any, founderData: any): Observable<any> {
    const formData = new FormData();

    const adminDataX = {
      nom: adminData?.name,
      prenoms: adminData?.surName,
      email: adminData?.email,
      password: adminData?.password,
      contact: adminData?.contact,
      fournisseurid: null,
      roleid: adminData.roleid,
    };

    const founderDataX = {
      nom: founderData.nom,
      description: founderData.description,
      paysname: founderData.paysname,
      contact: founderData.contact,
    };

    formData.append('administrateurDtoToString', JSON.stringify(adminDataX));
    formData.append('fournisseurDtoToString', JSON.stringify(founderDataX));

    return this.http.post<any>(`${this.BASE_URL}${SIGN_UP}`, formData);
  }

  resetPassword(data: any): Observable<any> {
    const formData = {
      codeotp: data.otp.toString(),
      newpassword: data.newPassword,
    };

    return this.http.put<any>(
      `${this.BASE_URL}${RESET_PASSWORD_API_URL}${data.email}`,
      JSON.stringify(formData),
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      }
    );
  }

  deleteAccount(id: number, uuid: string): Observable<any> {
    return this.http.delete<any>(
      `${this.BASE_URL}${DELETE_ADMIN_ACCOUNT_API_URL}${id}/${uuid}`
    );
  }

  forgotPassword(email: string): Observable<any> {
    return this.http.get<any>(
      `${this.BASE_URL}${FORGOT_PASSWORD_API_URL}${email}`
    );
  }

}
